import CourseCard from '@Components/Cards/CourseCard'
import SkeletonCard from '@Components/Utilities/Skeleton/Components/SkeletonCard'
import SkeletonCarousel from '@Components/Utilities/Skeleton/Components/SkeletonCarousel'
import { Swiper } from '@Components/Utilities/Swiper'
import { useGetMyStandaloneCoursesQuery } from '@Features/StandaloneCourse/Api/StandaloneCourseApi'
import { SectionWrapper } from '@Features/LandingPage/Assets/LandingPage.styled'
import { useAppSelector } from '@Hooks/ReduxHooks'
import React from 'react'
import { useTranslation } from 'react-i18next'
import { SectionTitle } from '../Sections.styled'

/**
 * The student's purchased standalone courses — separate from MyClassroomsSection.
 * Self-hiding when the platform is off or the student owns no courses.
 */
const MyCoursesSection: React.FC = () => {
	const coursesEnabled = useAppSelector(s => s.settings.standalone_courses_enabled)
	const { data, isLoading, isFetching } = useGetMyStandaloneCoursesQuery({ page: 1, perPage: 10 }, { skip: !coursesEnabled })
	const [t] = useTranslation('courses')

	if (!coursesEnabled) return null

	return (
		<SkeletonCarousel my={'5.25rem'} isLoading={isLoading || isFetching} numberOfItems={4} renderComponent={<SkeletonCard />}>
			<SectionWrapper my={{ sm: '2.8rem', lg: '5.25rem' }}>
				{data && data.data.length > 0 && (
					<div>
						<SectionTitle>
							<label>{t('my_courses')}</label>
						</SectionTitle>
						<Swiper padding={'1rem'} gridGap={'2rem'}>
							{data.data.map((enrollmentRow, index) => {
								const course = enrollmentRow.standaloneCourse
								if (!course) return null
								return (
									<CourseCard
										key={`${course.id}-${index}-my-courses`}
										course={{ ...course, owned: true, enrollment: enrollmentRow }}
									/>
								)
							})}
						</Swiper>
					</div>
				)}
			</SectionWrapper>
		</SkeletonCarousel>
	)
}

export default MyCoursesSection
